import { EMPTY_GUID } from '@src/constants/guids';

import type { MittVerktoyItem, Verktoy } from '@src/types/minhelseentities';

export const mapToMittVerktoyItem = (verktoy: Verktoy): MittVerktoyItem => {
  return {
    VerktoyId: verktoy.VerktoyId,
    VerktoyNavn: verktoy.Navn,
    LaeringsaktivitetId: verktoy.Laeringsaktivitet?.LaeringsaktivitetId ?? 0,
    Begrunnelse: verktoy.Laeringsaktivitet?.Begrunnelse ?? null,
    LagtTilDato: verktoy.Laeringsaktivitet?.Opprettet ?? null,
    LagtTilAv: verktoy.Laeringsaktivitet?.OpprettetAvNavn ?? null,
    LagtTilAvTypeId: verktoy.Laeringsaktivitet?.OpprettetAvTypeId ?? null,
    Lenker: verktoy.Lenker ?? [],
    KreverForskrivning: verktoy.Laeringsressurs?.KreverForskrivning ?? false,
    VerktoyType: verktoy.Laeringsressurs?.VerktoyTyper ?? [],
    OppstartType: verktoy.OppstartType ?? 0,
    KanStartesAvInnloggetBruker: verktoy.KanStartesAvInnloggetBruker ?? false,
    GrafiskElementId: verktoy.GrafiskeElementer?.[0]?.Id ?? null,
    ErVerktoyTilgjengelig: verktoy.StatusType === 1,
    InterntVerktoy: verktoy.InterntVerktoy,
    LaeringsaktivitetGuid: EMPTY_GUID,
  };
};
